import component from './component'
import org from './org'
import menuPermissions from './menuPermissions'
import unit from './unit'
import select from './select'
import dataResource from './dataResource'
import rolePermissions from './rolePermissions'
import users from './users'
import menuRolePermissions from './menuRolePermissions'
import goodsLevel from './goodsLevel'
import dataType from './dataType'
import apps from './apps'
import tenement from './tenement'
import usfAdmin from './usfAdmin'
import menuResource from './menuResource'
import organizationsPermissions from './organizationsPermissions'
import dataRole from './dataRole'
import administrators from './administrators'
import dataRolePermissions from './dataRolePermissions'
import operationLog from './operationLog'
import interfaceAuth from './interfaceAuth'
import applyMenuPermission from './applyMenuPermission'
import cache from './cache'
import logo from './logo'
import organizations from './organizations'
import usersGroup from './usersGroup'
import applyUserGroup from './applyUserGroup'
import applyUserData from './applyUserData'
import batchAdministrators from './batchAdministrators'
import data from './data'
export {
    component,
    data,
    org,
    menuPermissions, // 我的菜单资源管理权限
    unit,
    select,
    dataResource, // 数据资源管理
    rolePermissions, //3.1.2 菜单角色管理
    users,
    menuRolePermissions, // 菜单角色管理权限
    goodsLevel,
    dataType, // 数据类型 whl
    apps, // 应用管理
    usfAdmin, // 平台管理员
    tenement,
    menuResource,
    dataRole, // 数据角色管理
    organizationsPermissions, //机构管理权限 4.3
    administrators, // 管理员 4.4,                                                                                                                                          
    dataRolePermissions, // 数据角色管理权限
    operationLog, // 操作日志
    interfaceAuth, // 接口授权
    applyMenuPermission, //申请菜单权限
    cache, //缓存工具
    logo,
    organizations,
    usersGroup, //用户组
    applyUserGroup, //用户组
    applyUserData,
    batchAdministrators
}
